// extracted by mini-css-extract-plugin
export default {"panel":"Pannel_panel__TNIZU","panelTitle":"Pannel_panelTitle__eDdp6"};